/**
 * JSON-LD 结构化数据构建器（Organization / WebSite / Product / FAQPage）。
 * 数据一律取自单一事实源 src/data/facts.js。
 */
import { company, founder, keyFacts, products, purchase, contact, faq } from "@/data/facts";
import { SITE_ORIGIN } from "@/utils/meta";

function organization() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: `${company.brandCn}（${company.brandEn}）`,
    legalName: company.fullName,
    url: SITE_ORIGIN + "/",
    foundingDate: String(company.founded),
    founder: {
      "@type": "Person",
      name: founder.name,
      jobTitle: founder.title,
      alumniOf: founder.education,
    },
    description: company.definition,
    contactPoint: {
      "@type": "ContactPoint",
      telephone: contact.phone,
      email: contact.bdEmail,
      contactType: "sales",
    },
    sameAs: contact.sameAs,
  };
}

function website() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: `${company.brandCn}${company.productName}`,
    url: SITE_ORIGIN + "/",
    inLanguage: "zh-CN",
  };
}

function productList() {
  return products.map((p) => ({
    "@context": "https://schema.org",
    "@type": "Product",
    name: `${company.productName} ${p.model}（${p.nickname}）`,
    brand: { "@type": "Brand", name: company.brandEn },
    description: `${p.position}：${p.forWhom}`,
    url: SITE_ORIGIN + p.route,
    offers: {
      "@type": "Offer",
      priceCurrency: "CNY",
      availability: "https://schema.org/InStock",
      url: `${purchase.tmallUrl}&${purchase.utm}`,
      seller: { "@type": "Organization", name: purchase.tmallStoreName },
    },
  }));
}

function faqPage() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
}

const builders = {
  organization: () => [organization()],
  website: () => [website()],
  products: () => productList(),
  faq: () => [faqPage()],
};

export function buildJsonLd(kinds) {
  return kinds.reduce((acc, kind) => {
    const builder = builders[kind];
    return builder ? acc.concat(builder()) : acc;
  }, []);
}



// WEBPACK FOOTER //
// ./src/utils/structuredData.js